/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { ComponentProps } from "react"

import { Button } from "../primitives/button"
import { Spinner } from "../primitives/spinner"

interface BusyButtonProps extends ComponentProps<typeof Button> {
    /**
     * Whether the action the button starts is still running.
     *
     * @default false
     */
    busy?: boolean
}

/**
 * A button with a busy state for actions that take time to complete.
 *
 * While busy, it shows a spinner and is disabled to prevent another activation,
 * including implicit form submission with Enter. The caller owns the state and
 * can pass `form.isSubmitting` or its own flag for actions outside a form.
 */
export const BusyButton = ({ busy = false, disabled, children, ...props }: BusyButtonProps) => (
    <Button {...props} disabled={disabled || busy} aria-busy={busy}>
        {busy && <Spinner data-icon="inline-start" aria-hidden />}
        {children}
    </Button>
)
